<form [formGroup]="form" fxLayout="column" class="form">
  <img src="assets/new-logo-2.png" alt="Bipperz logo" class="logo"/>
  <h2 class="title">{{ 'login_page.about_you' | translate }}</h2>

  <!-- Country -->
  <div class="country">
    <div class="label">{{ 'login_page.country' | translate }}</div>

    <app-dropdown
      [items]="countries"
      bindLabel="name"
      [clearable]="false"
      [multiple]="false"
      formControlName="country"
      placeholder="{{ 'login_page.choose_country' | translate }}"
    >
      <ng-template #optionTpl let-country>
        <div class="option">
          <img
            [src]="getFlagSrc(country)"
            [alt]="(country?.name ?? country) + ' flag'"
            style="width: 1rem;height: 1rem; border-radius: 2px;padding-right: 0.5rem;"
            class="flag"
          />
          <span>{{ country?.name ?? country }}</span>
        </div>
      </ng-template>

      <ng-template #selectedItemTpl let-country>
        <div class="selected-item">
          <img
            [src]="getFlagSrc(country)"
            [alt]="(country?.name ?? country) + ' flag'"
            style="width: 1rem;height: 1rem; border-radius: 2px;padding-right: 0.5rem;"
            class="flag"
          />
          <span>{{ country?.name }}</span>
        </div>
      </ng-template>
    </app-dropdown>
  </div>

  <!-- Looking for: REQUIRED -->
  <div class="looking-for" style="margin-top: 1rem;">
    <div class="label-looking-for">{{ 'registration.looking_for.label' | translate }}</div>
    <mat-button-toggle-group
      formControlName="lookingFor"
      appearance="legacy"
      class="referral-toggle-group"
      name="lookingFor"
      exclusive>
      <mat-button-toggle value="AUSBILDUNG_TRAINING">
        {{ 'registration.looking_for.ausbildung' | translate }}
      </mat-button-toggle>
      <mat-button-toggle value="FACHKRAFT_WORK">
        {{ 'registration.looking_for.fachkraft' | translate }}
      </mat-button-toggle>
    </mat-button-toggle-group>
  </div>

  <!-- Domain: REQUIRED -->
  <div class="domain" style="margin-top: 1rem;">
    <app-input
      style="width: 100%; padding-top: 1rem;"
      formControlName="domain"
      [withNoIcon]="true"
      [state]="InputState.REGULAR"
      [placeholder]="'registration.domain.label' | translate"
      [size]="InputSize.LARGER"
    ></app-input>

    <!-- Errors -->
    <div class="input-errors" *ngIf="form.get('domain')?.touched">
      <div *ngIf="form.get('domain')?.hasError('required')">
        {{ 'errors.domain_required' | translate }}
      </div>
    </div>

  </div>

  <!-- Referral source -->
  <div class="referral-source">
    <span class="label">{{ 'registration.referral.label' | translate }}</span>
    <mat-button-toggle-group
      formControlName="referralSource"
      appearance="legacy"
      class="referral-toggle-group"
      name="referralSource"
      exclusive>
      <mat-button-toggle value="partner">
        {{ 'registration.referral.partner' | translate }}
      </mat-button-toggle>
      <mat-button-toggle value="self">
        {{ 'registration.referral.self' | translate }}
      </mat-button-toggle>
    </mat-button-toggle-group>
  </div>

  <!-- Partner code input -->
  <div *ngIf="form.get('referralSource')?.value === 'partner'" class="partner-code">
    <mat-form-field style="width: 100%; padding-top: 1rem;" appearance="fill">
      <mat-label>{{ 'registration.referral.enter_code' | translate }}</mat-label>
      <input matInput formControlName="partnerCode" (input)="validatePartnerCode()" />
      <mat-hint *ngIf="codeValidated && isCodeValid" style="color: green">
        {{ 'registration.referral.valid_code' | translate }}
      </mat-hint>
      <mat-error *ngIf="codeValidated && !isCodeValid">
        {{ 'registration.referral.invalid_code' | translate }}
      </mat-error>
    </mat-form-field>
  </div>

  <!-- Continue -->
  <div class="continue-button">
    <app-button
      [isFullWidth]="true"
      [rightIcon]="'assets/icons/right-arrow.svg'"
      [label]="'auth.save_continue' | translate"
      [size]="ButtonSize.LARGE"
      [state]="isValidForm() ? ButtonState.REGULAR : ButtonState.DISABLED"
      [type]="ButtonType.PRIMARY"
      (click)="continue()"
    ></app-button>
  </div>
</form>
